import { Outlet, Navigate } from 'react-router-dom';
import { URLS } from '.';
import { useAuthStatus } from '../store/selectors/userSelector';
import PusherListener from '../components/PusherListener';

const PrivateRoutes = () => {
    const isAuth = useAuthStatus();
    // console.log('~~~~~~~~~~~~~~~~~~~~~~~~~', {isAuth})
    return (
        isAuth ? <><PusherListener /><Outlet /></> : <Navigate to={URLS.USER.LOGIN} />
    )
}

export default PrivateRoutes;